/**
 * Bank SVG Logo Mappings
 * Maps normalized bank names to SVG logo file paths
 */

export const BANK_SVG_MAPPINGS: Record<string, string> = {
  // Major Brazilian Banks
  'banco-do-brasil': '/logos/banks-svg/banco-do-brasil.svg',
  'santander': '/logos/banks-svg/santander.svg',
  'caixa': '/logos/banks-svg/caixa.svg',
  'bradesco': '/logos/banks-svg/bradesco.svg',
  'itau': '/logos/banks-svg/itau.svg',
  'nubank': '/logos/banks-svg/nubank.svg',
  'inter': '/logos/banks-svg/inter.svg',
  'c6-bank': '/logos/banks-svg/c6-bank.svg',
  'original': '/logos/banks-svg/original.svg',
  'picpay': '/logos/banks-svg/picpay.svg',
  'neon': '/logos/banks-svg/neon.svg',
  'btg-pactual': '/logos/banks-svg/btg-pactual.svg',

  // Additional Banks
  'abc-brasil': '/logos/banks-svg/abc-brasil.svg',
  'ailos': '/logos/banks-svg/ailos.svg',
  'asaas': '/logos/banks-svg/asaas.svg',
  'bk-bank': '/logos/banks-svg/bk-bank.svg',
  'bnp-paribas': '/logos/banks-svg/bnp-paribas.svg',
  'brb': '/logos/banks-svg/brb.svg',
  'banco-arbi': '/logos/banks-svg/banco-arbi.svg',
  'bmg': '/logos/banks-svg/bmg.svg',
  'banco-bmp': '/logos/banks-svg/banco-bmp.svg',
  'bs2': '/logos/banks-svg/bs2.svg',
  'banco-da-amazonia': '/logos/banks-svg/banco-da-amazonia.svg',
  'daycoval': '/logos/banks-svg/daycoval.svg',
  'banco-do-espirito-santo': '/logos/banks-svg/banco-do-espirito-santo.svg',
  'banco-do-para': '/logos/banks-svg/banco-do-para.svg',
  'banco-do-sergipe': '/logos/banks-svg/banco-do-sergipe.svg',
  'banco-do-nordeste': '/logos/banks-svg/banco-do-nordeste.svg',
  'banco-industrial-do-brasil': '/logos/banks-svg/banco-industrial-do-brasil.svg',
  'mercantil': '/logos/banks-svg/mercantil.svg',
  'banco-paulista': '/logos/banks-svg/banco-paulista.svg',
  'banco-pine': '/logos/banks-svg/banco-pine.svg',
  'banco-rendimento': '/logos/banks-svg/banco-rendimento.svg',
  'safra': '/logos/banks-svg/safra.svg',
  'banco-sofisa': '/logos/banks-svg/banco-sofisa.svg',
  'banco-topazio': '/logos/banks-svg/banco-topazio.svg',
  'tribanco': '/logos/banks-svg/tribanco.svg',
  'banco-votorantim': '/logos/banks-svg/banco-votorantim.svg',
  'bank-of-america': '/logos/banks-svg/bank-of-america.svg',
  'banrisul': '/logos/banks-svg/banrisul.svg',
  'bees-bank': '/logos/banks-svg/bees-bank.svg',
  'capitual': '/logos/banks-svg/capitual.svg',
  'conta-simples': '/logos/banks-svg/conta-simples.svg',
  'contbank': '/logos/banks-svg/contbank.svg',
  'cora': '/logos/banks-svg/cora.svg',
  'credisis': '/logos/banks-svg/credisis.svg',
  'cresol': '/logos/banks-svg/cresol.svg',
  'duepay': '/logos/banks-svg/duepay.svg',
  'efi': '/logos/banks-svg/efi.svg',
  'grafeno': '/logos/banks-svg/grafeno.svg',
  'ifood-pago': '/logos/banks-svg/ifood-pago.svg',
  'infinitepay': '/logos/banks-svg/infinitepay.svg',
  'ip4y': '/logos/banks-svg/ip4y.svg',
  'iugo': '/logos/banks-svg/iugo.svg',
  'lets-bank': '/logos/banks-svg/lets-bank.svg',
  'linker': '/logos/banks-svg/linker.svg',
  'mufg': '/logos/banks-svg/mufg.svg',
  'magalupay': '/logos/banks-svg/magalupay.svg',
  'mercado-pago': '/logos/banks-svg/mercado-pago.svg',
  'modobank': '/logos/banks-svg/modobank.svg',
  'multiplo-bank': '/logos/banks-svg/multiplo-bank.svg',
  'omie-cash': '/logos/banks-svg/omie-cash.svg',
  'omni': '/logos/banks-svg/omni.svg',
  'pagseguro': '/logos/banks-svg/pagseguro.svg',
  'paycash': '/logos/banks-svg/paycash.svg',
  'pinbank': '/logos/banks-svg/pinbank.svg',
  'quality-digital-bank': '/logos/banks-svg/quality-digital-bank.svg',
  'recargapay': '/logos/banks-svg/recargapay.svg',
  'sicoob': '/logos/banks-svg/sicoob.svg',
  'sicredi': '/logos/banks-svg/sicredi.svg',
  'sisprime': '/logos/banks-svg/sisprime.svg',
  'squid': '/logos/banks-svg/squid.svg',
  'starbank': '/logos/banks-svg/starbank.svg',
  'stone': '/logos/banks-svg/stone.svg',
  'sulcredi': '/logos/banks-svg/sulcredi.svg',
  'transfera': '/logos/banks-svg/transfera.svg',
  'unicred': '/logos/banks-svg/unicred.svg',
  'uniprime': '/logos/banks-svg/uniprime.svg',
  'xp-investimentos': '/logos/banks-svg/xp-investimentos.svg',
  'zemo-bank': '/logos/banks-svg/zemo-bank.svg'
};

/**
 * Get bank SVG logo path by normalized name
 */
export function getBankSvgPath(normalizedName: string): string {
  return BANK_SVG_MAPPINGS[normalizedName] || '';
}

/**
 * Check if bank has SVG logo available
 */
export function hasBankSvgLogo(normalizedName: string): boolean {
  return normalizedName in BANK_SVG_MAPPINGS;
}

/**
 * Get all available bank SVG logos
 */
export function getAllBankSvgLogos(): Array<{ name: string; path: string }> {
  return Object.entries(BANK_SVG_MAPPINGS).map(([name, path]) => ({ name, path }));
}
